(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zoh-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!window.zohHomeTracking) {
 window.zohHomeTracking = true;
 document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-zoh-promotion],a[data-zoh-banner]');
  if (!link || window.Shopify?.designMode) return;
  const privacy = window.Shopify?.customerPrivacy;
  if (!privacy || !privacy.analyticsProcessingAllowed()) return;
  const promotion = {promotion_id:link.dataset.zohPromotion || link.dataset.zohBanner,promotion_name:link.textContent.trim(),creative_slot:link.dataset.zohPosition || "homepage",link_url:link.href};
  if (typeof window.gtag === 'function') window.gtag('event','select_promotion',promotion);
  if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('zoh_home_promotion_click',promotion);
 });
}

  } catch(e) { console.error(e); }
})();
})();
